var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.099 37.483H18.907a4.614 4.614 0 01-4.614-4.614V15.69a4.614 4.614 0 014.614-4.614h12.374a4.614 4.614 0 014.614 4.614v17.449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.566 28.708a4.17 4.17 0 01-2.942-3.985V9.204a4.168 4.168 0 014.168-4.168H21.97c1.092 0 2.087.42 2.83 1.108M20.279 24.28h9.631M25.095 19.464v9.631"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 25.095,
    cy: 24.28,
    r: 1.444
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMultiple);
export default __webpack_public_path__ + "static/media/addMultiple.2fb2dd40b15007b876f9a4f30fe3170c.svg";
export { ForwardRef as ReactComponent };